export function userFriendlyFileSize(file) {
  if (file?.size > 1 << 20) return `${(file?.size / (1 << 20)) | 0} MB`;
  if (file?.size > 1 << 10) return `${(file?.size / (1 << 10)) | 0} KB`;
  if (file?.size) return `${file?.size} Bytes`;
  return 'Provided argument does not contain a "size" property';
}
